import React from 'react';

// Toolbar UI CONDIVISA della modalità "collega superserie" (scheda + libero).
// L'ingresso alla modalità avviene dal menu del pulsante "+" (AddActionsSheet),
// quindi qui NON c'è più il pulsante fisso: si mostra solo durante la selezione.
function SupersetLinkBar({ linkMode, count, onConfirm, onCancel }) {
  if (!linkMode) return null;

  return (
    <div className="p-3 rounded-xl bg-primary-50 border border-primary-200">
      <div className="text-sm font-semibold text-primary-800 mb-2">
        Seleziona 2 o più esercizi da collegare <span className="font-normal">({count})</span>
      </div>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={onCancel}
          className="flex-1 py-2 px-3 rounded-lg bg-white text-gray-700 text-sm font-semibold border border-gray-200 hover:bg-gray-50 transition-colors"
        >
          Annulla
        </button>
        <button
          type="button"
          onClick={onConfirm}
          disabled={count < 2}
          className="flex-1 py-2 px-3 rounded-lg gradient-primary text-white text-sm font-semibold shadow disabled:opacity-40 disabled:cursor-not-allowed transition-all active:scale-98"
        >
          Crea superserie
        </button>
      </div>
    </div>
  );
}

export default SupersetLinkBar;
